import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';
import image from '../../../assets/marketPlace.png';

// High-tech Job & Crew Icons
import WorkRoundedIcon from '@mui/icons-material/WorkRounded';
import MovieFilterRoundedIcon from '@mui/icons-material/MovieFilterRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded';
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded';

const JobsIndustry = () => {
  return (
    <IndustryPageTemplate
      title="Jobs & Crew"
      subtitle="Film Industry Job Board & Crew Hiring Directory"
      desc="Hire certified directors of photography, sound engineers, VFX artists, gaffers, and editors for your film and television productions. Search thousands of active gigs with transparent day rates and smart milestone escrow."
      image={image}
      themeColor="#06b6d4"
      bgGradient="linear-gradient(135deg, rgba(6,182,212,0.2) 0%, rgba(6,182,212,0.02) 100%)"
      marqueeItems={[
        { icon: '💼', tag: 'CREW HIRED', text: 'DP Marcus Vance hired for 6-week feature film shoot in Vancouver', time: '1m ago', color: '#06b6d4' },
        { icon: '🎬', tag: 'NEW GIG', text: 'Paramount posted Lead VFX Compositor contract at $850/Day', time: '4m ago', color: '#10b981' },
        { icon: '🎚️', tag: 'SOUND CREW', text: 'Dolby Atmos certified Boom Operator booked for commercial shoot', time: '7m ago', color: '#07a4f5' },
        { icon: '⚡', tag: 'RUSH CALL', text: 'Emergency Gaffer replacement dispatched to studio in 45 minutes', time: '11m ago', color: '#f59e0b' },
        { icon: '🛡️', tag: 'VERIFIED CREW', text: 'Camera Assistant verified with 14 union film production credits', time: '16m ago', color: '#8b5cf6' },
        { icon: '💰', tag: 'ESCROW PAID', text: '$18,500 milestone payment released for feature film rough cut', time: '22m ago', color: '#ec4899' },
      ]}
      features={[
        {
          id: 'crew-hiring',
          icon: <WorkRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Full Production Crew Hiring',
          desc: 'Hire verified DPs, camera operators, gaffers, grips, sound recordists, and production managers with verified past credits.',
          badge: 'Crew Directory',
          metric: '12.4K+ Crew Verified',
          highlight: 'Certified Credits',
          hasPulse: true,
        },
        {
          id: 'post-vfx',
          icon: <MovieFilterRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Post-Production & VFX Contracts',
          desc: 'Find specialized 3D Unreal Engine artists, colorists, sound designers, and offline NLE editors for remote and on-set workflows.',
          badge: 'Post & VFX',
          metric: '3,200+ VFX Artists',
          highlight: '4K ProRes Delivery',
          hasEqualizer: true,
        },
        {
          id: 'rates',
          icon: <PaymentsRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Transparent Union & Day Rates',
          desc: 'Standardized rate cards for SAG-AFTRA, IATSE, and independent productions with automated overtime and meal calculations.',
          badge: 'Standard Rates',
          metric: '100% Rate Transparency',
          highlight: 'Union & Indie Specs',
        },
        {
          id: 'portfolio',
          icon: <BadgeRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Verified Industry Credential Cards',
          desc: 'Comprehensive verified work history linked with IMDb, Filmhook trailers, and verified peer recommendations.',
          badge: 'Verified ID',
          metric: 'IMDb Synced Profiles',
          highlight: 'Zero Fake Credits',
        },
        {
          id: 'rush-crew',
          icon: <SpeedRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Rush Emergency Crew Dispatch',
          desc: 'Need a replacement AC, sound tech, or grip on set right now? Dispatch verified nearby crew with sub-2 hour arrival guarantee.',
          badge: 'Rush Dispatch',
          metric: '< 2h On-Set Arrival',
          highlight: 'GPS Proximity Search',
        },
        {
          id: 'escrow-payout',
          icon: <HandshakeRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Milestone Escrow & Instant Payout',
          desc: 'Funds are securely locked in smart contract escrow prior to call time and released automatically upon wrap with 0% platform delay.',
          badge: 'Smart Escrow',
          metric: 'Zero Payment Delays',
          highlight: 'Guaranteed Funds',
        },
      ]}
    />
  );
};

export default JobsIndustry;
